var _defs, _title, _circle, _path, _rect, _rect2, _rect3, _rect4, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgRequestAccessDog = function SvgRequestAccessDog(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 140 140",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 60.43,
    y1: 45.61,
    x2: 60.43,
    y2: 28.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef0f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#f4f6f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 60.43,
    y1: 66.19,
    x2: 60.43,
    y2: 49.01,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 79.08,
    y1: 45.52,
    x2: 79.08,
    y2: 28.34,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 79.08,
    y1: 66.1,
    x2: 79.08,
    y2: 48.92,
    xlinkHref: "#a"
  }))), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Request Access Dog")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70.4,
    r: 60,
    fill: "#edf0f2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.9,24.5H51.1a1.9,1.9,0,0,0-1.8,1.3,2,2,0,0,0-.3,1.1V102a2.3,2.3,0,0,0,2.1,2.4H89.2A2.4,2.4,0,0,0,91,102V26.9A2.3,2.3,0,0,0,88.9,24.5Z",
    fill: "#9cadb5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52.8,
    y: 28.4,
    width: 15.2,
    height: 17.18,
    fill: "url(#a)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52.8,
    y: 49,
    width: 15.2,
    height: 17.18,
    fill: "url(#b)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 71.5,
    y: 28.3,
    width: 15.2,
    height: 17.18,
    fill: "url(#c)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 71.5,
    y: 48.9,
    width: 15.2,
    height: 17.18,
    fill: "url(#d)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.3,
    cy: 73.8,
    r: 2.8,
    fill: "#ced6d9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9,107.7a2.1,2.1,0,0,0-1.9-1.1H51a2.1,2.1,0,0,0-1.9,1.1l-5.2,8.9H96.2Z",
    fill: "#ced6d9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.5,21.9h0V14.1c0-.2-.1-.3-.2-.5h-.5l-6.1,1.3a.7.7,0,0,0-.4.6v5.9h-.8a1.8,1.8,0,0,0-2,1.6,1.8,1.8,0,0,0,2,1.7,1.9,1.9,0,0,0,2-1.7h0V17.9l4.8-1v3.6h-.8a1.8,1.8,0,0,0-2,1.6,2,2,0,0,0,4,0Zm-6-5.2v-.8l4.8-1v.8Z",
    fill: "#fbd149"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4,31.2h-.6a.6.6,0,0,0-.3.6v5.9h-.8a1.7,1.7,0,1,0,0,3.3,1.9,1.9,0,0,0,2-1.7h0V32.9a2.6,2.6,0,0,1,1.1,1.6,1.8,1.8,0,0,1-.3,1.3.6.6,0,0,0,0,.9.6.6,0,0,0,.8,0,2.8,2.8,0,0,0,.7-2.3C100.8,33.2,100,32.2,98.4,31.2Z",
    fill: "#fbd149"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4,9.7a.5.5,0,0,0-.6-.1.7.7,0,0,0-.3.6v5.9h-.8a1.7,1.7,0,0,0-1.9,1.6,1.8,1.8,0,0,0,1.9,1.7,1.8,1.8,0,0,0,2-1.7h0V11.3A2.8,2.8,0,0,1,91.8,13a2.4,2.4,0,0,1-.3,1.3.5.5,0,0,0,0,.8.7.7,0,0,0,.9,0,3.4,3.4,0,0,0,.6-2.3A4.5,4.5,0,0,0,90.4,9.7Z",
    fill: "#fbd149"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8,79.8s-2.3.8-3.2-.5-1.8-2.2-2.8-1.1-6,6.1-4.4,8.4,4.2,1.9,4.6.1.1-6.2,1.1-5.8,1.4,1.5,3.5.7Z",
    fill: "#3c5b6c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1,77.8c-1-1.1-2-.3-2.8,1s-.2.3-.3.3a7.9,7.9,0,0,0-2.5-1.5h-.1s-2.6,1.5-2.1,3,4.1,1.5,3.9,2.9-.6,2.9.5,3.4h.2a6,6,0,0,0,1.8-4.2,4.6,4.6,0,0,0-.5-2l.6-.3c1-.4.7,4,1.1,5.8s3.1,2.2,4.6-.1S79.2,78.9,78.1,77.8Z",
    fill: "#3c5b6c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7,109.7H78a9.6,9.6,0,0,0,1.9-6,8.8,8.8,0,0,0-3.4-7.3c-1.1-2.9-2.4-5.8-3.5-8.1L74.9,87h-.2c-1.1-.5-.7-2.1-.5-3.4s-3.4-1.4-3.9-2.9,2.1-3,2.1-3h.1a7.7,7.7,0,0,0-2.7-.4c-3.7.1-6.6,2.8-6.5,6a6,6,0,0,0,3.5,5c-1.2,2.4-2.5,5.5-3.7,8.5a9.2,9.2,0,0,0-3,7,10,10,0,0,0,1.2,5,3.6,3.6,0,0,0,.7,1H60.3a1.7,1.7,0,0,0-1.7,1.7.8.8,0,0,0,.8.9H67l3,.2,3.1-.2h7.5a.8.8,0,0,0,.8-.9A1.7,1.7,0,0,0,79.7,109.7Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5,105.6c.3-2.4,2.3-6.7.5-7.2s-12.7,7.2-5.8,11.5l2.1,1.2c-1.3,2.1-4.3,6.6-8.9,7.1h1.4a14.3,14.3,0,0,0,6.3-1.4h.1l-1.2.2h.1a5,5,0,0,0,1.7-.4h.1l1.1-.7c0-.1.1-.1.1-.2H66.4a14.2,14.2,0,0,0,3.4-.8v-.2A8.3,8.3,0,0,0,71,112a2.5,2.5,0,0,0,2.4-1.3C74.6,108.3,71.1,108,71.5,105.6Z",
    fill: "#3c5b6c"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRequestAccessDog, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/request-access-dog.23608a5f.svg";
export { ForwardRef as ReactComponent };